import React from "react";
import LandingHeader from "../components/LandingHeader";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import {
  SearchCircleIcon,
  SearchIcon,
  TrashIcon,
} from "@heroicons/react/outline";
import SearchQuestionHeader from "../components/SearchQuestionHeader";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import backendService from "../services.js/backendService";
import "react-toastify/dist/ReactToastify.css";
import { useBeforeunload, Beforeunload } from "react-beforeunload";
import toastProp from "../global/toastProps";
import { ShimmerText } from "react-shimmer-effects";

function MyQuestions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [questions, setQuestions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  
  const getQuestions = async () => {
    setLoading(true);

    await axios
      .get(`${process.env.REACT_APP_URL}/myquestions`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      })
      .then((res) => {
        setLoading(false);

        setQuestions(res.data.questions);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const deleteQuestion = async (id) => {
    await axios
      .delete(`${process.env.REACT_APP_URL}/deletequestion/${id}`, {
        headers: {
          "x-auth-token": backendService.getToken(),
        },
      })
      .then((res) => {
       
        getQuestions();
        toast.success("Question deleted successfully", toastProp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  React.useEffect(() => {
    getQuestions();
  }, []);
  return (
    <div className="h-screen">
      {/* header  */}
      <SearchQuestionHeader />
      {/* body  */}
      <body className="h-[90%] overflow-x-hidden overflow-y-auto chat__container">
        <div className="h-full">
          {/* Question area */}
          <div className="h-[91%]  "> {/* This height might need to be flex-1 if parent is flex-col and has a fixed height header */}
            {/* heading */}
            <div className="min-h-[10vh] sm:min-h-0 py-6 sm:py-8 md:py-10 flex items-center text-xl sm:text-2xl px-4 sm:px-6 md:px-8 lg:px-12 xl:pl-20">
              My Questions
            </div>
            {/* top question list */}
            <div className="w-full flex justify-center">
              {
                <div className="w-full px-2 sm:w-11/12 md:w-10/12 lg:w-9/12 xl:w-8/12 mx-auto cursor-pointer">
                  {/* question card */}

                  {loading ? (
                    <div className="">
                      <ShimmerText line={5} gap={10} />
                      <ShimmerText line={5} gap={10} />
                      <ShimmerText line={5} gap={10} />
                      <ShimmerText line={5} gap={10} />
                    </div>
                  ) : questions?.length > 0 ? (
                    questions?.map((question) => (
                      <div key={question?._id} className="flex flex-col sm:flex-row sm:h-[100px] p-3 sm:p-4 border-y-[1px] border-gray-300">
                        <div className="w-full sm:w-[15%] md:w-[10%] flex flex-row sm:flex-col items-baseline sm:items-center justify-start sm:justify-center space-x-2 sm:space-x-0 sm:space-y-1 text-xs sm:text-sm mb-2 sm:mb-0 sm:mr-3">
                          <div>{question?.views?.length} views</div>
                          <div>{question.answers.length} answers</div>
                        </div>
                        <div className="w-full sm:flex-grow min-w-0">
                          <h3
                            className="text-md sm:text-lg" // Added truncate potentially if title is long
                            onClick={() =>
                              navigate(`/question/${question._id}`)
                            }
                          >
                            {question.title}
                          </h3>
                          <div className="flex flex-wrap space-x-1 sm:space-x-2 mt-1">
                            {question.tags.map((tag) => (
                              <h3
                                className="text-xs sm:text-sm text-palette_color1" // Removed pl-2, relying on space-x
                                onClick={() => {
                                  navigate(`/forum/${tag}`);
                                }}
                                key={tag} // Added key for list items
                              >
                                {"#" + tag}{" "}
                              </h3>
                            ))}
                          </div>
                        </div>
                        <div className="w-full sm:w-auto text-xs mt-2 sm:mt-0 sm:ml-auto flex items-center justify-between sm:justify-end space-x-2">
                          <span className="whitespace-nowrap">{moment(question.createdAt).format("MMM Do YY")}</span>
                          <button
                            className="bg-red-500 border-[1px] border-red-500 hover:bg-palette_color2 text-white hover:text-red-500 px-1 py-1 rounded shadow-sm hover:border hover:border-red-500 ease-linear transition-all duration-500"
                            onClick={async () => {
                              await deleteQuestion(question._id);
                            }}
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-lg">
                      You Have Not Posted Any Questions Yet
                    </div>
                  )}
                </div>
              }
            </div>
            <button
              className="fixed bottom-6 right-6 sm:absolute sm:bottom-8 sm:right-16 z-10 py-2 px-4 sm:py-3 sm:px-6 rounded-md shadow font-semibold bg-palette_color1 hover:opacity-90 antialiased hover:subpixel-antialiased text-white"
              onClick={() => {
                backendService.isLoggedIn()
                  ? navigate("/askquestion")
                  : navigate("/login", {
                      state: { redirect: location.pathname },
                    });
              }}
            >
              Ask Question?
            </button>
          </div>
        </div>
      </body>
    </div>
  );
}
export default MyQuestions;
